/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_appsync_graphqlEndpoint": "https://4w6fckolundf3a7cly54nf4u4e.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "ap-northeast-1:87a13a73-20e0-4b9e-82dd-f759d9d43426",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_GaQ5r4PBq",
    "aws_user_pools_web_client_id": "2150ejt38e5jbmv20d7ogvfkp5",
    "oauth": {
        "domain": "journeycycledce991c2-dce991c2-production.auth.ap-northeast-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.jourcy.com/,https://prod.d231hkkpjy5s7y.amplifyapp.com/,https://stg.d231hkkpjy5s7y.amplifyapp.com/,http://localhost:3000/",
        "redirectSignOut": "https://app.jourcy.com/,https://prod.d231hkkpjy5s7y.amplifyapp.com/,https://stg.d231hkkpjy5s7y.amplifyapp.com/,http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "ap-northeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "MapSequence-production",
            "region": "ap-northeast-1"
        }
    ]
};


export default awsmobile;
